import styled, { DefaultTheme, css } from 'styled-components';

import { Grid as StyledGrid } from '../../micros/Layout/Grid/styles';
import { Row } from '../../micros/Layout/Row/styles';

import { SectionStyleProps } from './types';

const modifier = {
	marginBottom: (theme: DefaultTheme) => css`
		margin-bottom: 6.4rem;

		@media (min-width: ${theme.breakpoints.desktop}) {
			margin-bottom: 9.6rem;
		}
	`,
};

export const Container = styled.section<SectionStyleProps>`
	${({ theme, marginBottom }) => css`
		${marginBottom === 'default' && modifier.marginBottom(theme)}
		.arrow-prev,
		.arrow-next {
			display: none;
		}
		.keen-slider__slide {
			height: 100%;
		}
		@media (min-width: ${theme.breakpoints.desktop}) {
			.arrow-prev,
			.arrow-next {
				display: block;
			}
		}
	`}
`;

export const Grid = styled(StyledGrid)`
	${({ theme }) => css`
		@media (max-width: ${theme.breakpoints.tabletLandscape}) {
			margin-right: 0;
		}
	`}
`;

export const GridItem = styled(Row)`
	${({ theme }) => css`
		display: flex;
		gap: 1.6rem;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			gap: 2.4rem;
		}

		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			gap: 1.6rem;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			gap: 2.4rem;
		}
	`}
`;

export const GridItemBox = styled(Row)`
	margin-bottom: 1.6rem;
`;

export const Heading = styled.h2`
	${({ theme }) => css`
		font-size: ${theme.font.sizes.large};
		color: ${theme.colors.black100};
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.medium};
		line-height: 22px;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			font-size: ${theme.font.sizes.xxlarge};
			line-height: 3.6rem;
		}
		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			font-size: ${theme.font.sizes.xxlarge};
			line-height: 3.6rem;
		}
		@media (min-width: ${theme.breakpoints.desktop}) {
			font-size: ${theme.font.sizes.big};
			line-height: 3.6rem;
		}
	`}
`;

export const WrapperCarouselChips = styled.div`
	${({ theme }) => css`
		overflow: auto;
		margin-bottom: 2.4rem;
		padding: 2px;

		&::-webkit-scrollbar {
			display: none;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			margin-bottom: 3.2rem;
		}
	`}
`;

export const ContainerCarouselChips = styled.div`
	${({ theme }) => css`
		display: flex;
		flex-wrap: wrap;
		gap: 1.6rem;

		@media (max-width: ${theme.breakpoints.tabletPortrait}) {
			flex-wrap: nowrap;
			overflow-x: scroll;
			::-webkit-scrollbar {
				width: 0;
			}
		}

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			gap: 2rem;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			gap: 1rem;
		}

		@media (min-width: ${theme.breakpoints.ultraWide}) {
			max-width: ${theme.grid.ultraWide};
			margin: 0 auto;
			gap: 2rem;
		}
	`}
`;

export const ContainerButton = styled(Row)`
	${({ theme }) => css`
		display: flex;
		justify-content: center;
		margin-top: ${theme.spacings.large};
	`}
`;

export const CarouselItem = styled.div``;
